export class ApiError extends Error {
  constructor(data, statusCode) {
    super(data.message);
    this.name = 'ApiError';
    this.message = data.message;
    this.trackingId = data.trackingId;
    this.errorCode = data.code;
    this.statusCode = statusCode;
    this.errors = data.errores;
    Error.captureStackTrace(this, this.constructor);
  }
}

export default ApiError;
